import { validateRequired } from './validateProperties';

const requiredValidatorCreator = message => required => ({
  validate: value => validateRequired(value, required),
  message
});

const getValidationMessage = (
  validator,
  value,
  requiredCreator = requiredValidatorCreator(validator.message)
) => {
  const requiredValidator = requiredCreator(validator.required);
  let validationMessage = !validator.validate(value) ? validator.message : null;

  if (!validationMessage && validator.required) {
    validationMessage = !requiredValidator.validate(value) ? requiredValidator.message : null;
  }

  return validationMessage;
};

export const createRequiredValidator = (required, message) =>
  requiredValidatorCreator(message)(required);

const emptyRequiredValidator = createRequiredValidator(false, null);

export const validate = (
  value,
  { validators = [], requiredValidator = emptyRequiredValidator }
) => {
  let message;
  const validatorObjects = Array.isArray(validators) ? validators : [validators];

  if (requiredValidator !== emptyRequiredValidator) {
    message = getValidationMessage(requiredValidator, value);
  }

  for (let i = 0; i < validatorObjects.length && !message; i++) {
    message = getValidationMessage(
      validatorObjects[i],
      value,
      requiredValidatorCreator(requiredValidator.message)
    );
  }

  return message;
};
